import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ArgonDashboard from './plugins/argon-dashboard'
import store from './store'
import SmartTable from 'vuejs-smart-table'
import VueScrollTo from 'vue-scrollto';
import VueSlideoutPanel from 'vue2-slideout-panel';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import HighchartsVue from 'highcharts-vue'
import VueAnalytics from 'vue-analytics'

import 'sweetalert2/src/sweetalert2.scss'
import './plugins/number'
import './plugins/wording'
import './plugins/style'

Vue.config.productionTip = false;
Vue.use(ArgonDashboard);
Vue.use(SmartTable);
Vue.use(VueScrollTo);
Vue.use(VueSlideoutPanel);
Vue.component(VueQrcode.name, VueQrcode);
Vue.use(HighchartsVue)


import {
    GET_TOKEN,
    GET_USER_INFO
} from "./store/actions.type";

async function init() {
    // get token
    let token = await store.dispatch(GET_TOKEN);
    if (token) {
        await store.dispatch(GET_USER_INFO);
    }
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
}

init();





